export default "__VITE_ASSET__DsSK5MLt__"